goog.provide("shadow.js.shim.module$$mui$material$Fade");
goog.provide("module$shadow_js_shim_module$$mui$material$Fade");
shadow.js.shim.module$$mui$material$Fade = shadow.js.nativeProvides["@mui/material/Fade"] = shadow$bridge("@mui/material/Fade");
module$shadow_js_shim_module$$mui$material$Fade.default = shadow.js.shim.module$$mui$material$Fade;
